import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, RadioGroup } from 'components/common/form';

import type { Achievement } from 'shared-types';

interface Props {
  updateSupervisors: () => Promise<void>;
}

const AchievementSupervisorsSettingsButton = ({ updateSupervisors }: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { achievement }
  } = useReduxState();

  const handleSubmit = async (values: {
    supervisorAccess: Achievement['supervisorAccess'];
  }) => {
    const response = await api.put(`/admin/achievements/${achievement.id}`, {
      ...values
    });

    if (response?.data?.success) {
      dispatch(
        actions.updatePageState({
          achievement: { ...achievement, ...values }
        })
      );
      dispatch(
        actions.addNotice({
          text: messages.settingsSavedSuccessfully,
          type: 'success'
        })
      );
      await updateSupervisors();
    } else {
      throw new Error('error updating achievement');
    }
  };

  return (
    <ModalButtonWithForm
      buttonCategory="lighter"
      buttonIcon="cog"
      buttonProps={{ iconStyle: { fontSize: '1rem', marginRight: 3 } }}
      buttonSize="small"
      buttonStyle={{
        borderRadius: 30,
        padding: '3px 10px 4px 8px',
        margin: '-2px 0',
        position: 'relative',
        top: -1
      }}
      buttonText={messages.commonSettings}
      formAllowEmptyStrings={true}
      initialValues={{ supervisorAccess: achievement.supervisorAccess }}
      modalActionCategory="success"
      modalActionText={messages.commonSaveChanges}
      modalTitle={messages.commonSettings}
      modalWidth="medium"
      onSubmit={handleSubmit}
    >
      {() => (
        <FormGroup label={messages.achievementAllowAllSupervisors}>
          <RadioGroup
            field="supervisorAccess"
            id="supervisor-access"
            options={[
              {
                id: 'supervisor-access-added',
                label: messages.achievementSupervisorAccessAdded,
                value: 'added'
              },
              {
                id: 'supervisor-access-added-and-conditions',
                label: messages.achievementSupervisorAccessConditions,
                value: 'added-and-conditions'
              },
              {
                id: 'supervisor-access-all',
                label: messages.achievementSupervisorAccessAll,
                value: 'all'
              }
            ]}
          />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default AchievementSupervisorsSettingsButton;
